import { Component, OnInit, OnDestroy } from '@angular/core';
import { RxComposite } from '../model/rx-composite';

import { UploadFileService } from '@nrwl/rx-upload-service';
import { map } from 'rxjs/operators';
import { SnackbarService } from '@nrwl/snackbar-services';
import { CommonModule } from '@angular/common';
import { RxUploadModule } from '@nrwl/rx-upload';

@Component({
  selector: 'rx-file-upload',
  templateUrl: './rx-file-upload.component.html',
  styleUrls: ['./rx-file-upload.component.scss'],
  imports: [CommonModule, RxUploadModule],
})
export class RxFileUploadComponent extends RxComposite implements OnInit, OnDestroy {
  public progress;

  constructor(
    private uploadFileService: UploadFileService,
    private snackbarService: SnackbarService,
  ) {
    super();
  }

  ngOnInit() {}

  ngOnDestroy() {}

  uploadFile(e) {
    e.forEach((element) => {
      this.uploadFileService
        .uploadMediaFile(element)
        .pipe(
          map(
            (res: any) => {
              if (res) {
                this.uploadFileService.saveMedia = { pk: res.id, content_type: 0 };
                this.uploadFileService.uploadMedia = res;
                this.snackbarService.success('File upload to server');
              }
            },
            () => {
              this.snackbarService.error('Uploaded failed. Please try again');
            },
          ),
        )
        .subscribe();
    });
  }
}
